import React from 'react';

import { TableProps } from '@amzn/awsui-components-console/table';
import Box from '@amzn/awsui-components-console/box';
import Link from '@amzn/awsui-components-console/link';
import SpaceBetween from '@amzn/awsui-components-console/space-between';

import { StringGroupItem } from 'src/generated/graphql';
import { formatEpochDate } from './utils';
import ExpandableCell from 'src/features/namespace/components/ExpandableCell';

export const STRING_GROUP_COLUMNS: TableProps.ColumnDefinition<StringGroupItem>[] =
  [
    {
      id: 'stringGroupId',
      header: 'Name',
      minWidth: 140,
      sortingField: 'stringGroupId',
      cell: (item) => (
        // TODO: Link to string group detail page once route is implemented
        <Link variant="secondary" href="#">
          {item.stringGroupId}
        </Link>
      ),
    },
    {
      id: 'teamName',
      header: 'Team Name',
      minWidth: 80,
      sortingField: 'teamName',
      cell: (item) => item.teamName ?? '—',
    },
    {
      id: 'cxFamilyId',
      header: 'CX Family',
      minWidth: 90,
      sortingComparator: (a, b) =>
        (a.latestVersion?.cxFamilyId ?? '').localeCompare(
          b.latestVersion?.cxFamilyId ?? '',
        ),
      cell: (item) => item.latestVersion?.cxFamilyId ?? '—',
    },
    {
      id: 'cxIds',
      header: 'CX IDs',
      minWidth: 100,
      cell: (item) => (
        <ExpandableCell items={item.latestVersion?.cxIds} maxVisible={3} />
      ),
    },
    {
      id: 'sourceLocale',
      header: 'Source locale',
      width: 100,
      cell: (item) => item.latestVersion?.sourceLocale ?? '—',
    },
    {
      id: 'stringCount',
      header: 'String Count',
      width: 100,
      sortingComparator: (a, b) =>
        (a.latestVersion?.stringCount ?? 0) -
        (b.latestVersion?.stringCount ?? 0),
      cell: (item) => item.latestVersion?.stringCount ?? '—',
    },
    {
      id: 'createdAt',
      header: 'Created At',
      minWidth: 120,
      sortingComparator: (a, b) => (a.createdAt ?? 0) - (b.createdAt ?? 0),
      cell: (item) => (
        <SpaceBetween direction="horizontal" size="xs">
          <Box variant="span">{formatEpochDate(item?.createdAt)}</Box>
          {item?.createdBy && (
            <Box variant="span" color="text-body-secondary">
              by {item.createdBy}
            </Box>
          )}
        </SpaceBetween>
      ),
    },
    {
      id: 'updatedAt',
      header: 'Updated At',
      minWidth: 120,
      sortingComparator: (a, b) =>
        (a.latestVersion?.updatedAt ?? 0) - (b.latestVersion?.updatedAt ?? 0),
      cell: (item) => (
        <SpaceBetween direction="horizontal" size="xs">
          <Box variant="span">
            {formatEpochDate(item.latestVersion?.updatedAt)}
          </Box>
          {item.latestVersion?.updatedBy && (
            <Box variant="span" color="text-body-secondary">
              by {item.latestVersion.updatedBy}
            </Box>
          )}
        </SpaceBetween>
      ),
    },
  ];
